export default __webpack_public_path__ + "static/card-ramengo-banner-5cbbe1ce170189c3bce0b755ca9cb80f.png";